
import { useStats } from '@/hooks/useStats';
import { Widget } from '../Widget';

interface TodayStatsWidgetProps {
  isEditMode?: boolean;
}

export function TodayStatsWidget({ isEditMode }: TodayStatsWidgetProps) {
  const { stats, isLoading } = useStats();

  if (isLoading) {
    return (
      <Widget id="today-stats" title="Recent Activity" isEditMode={isEditMode}>
        <div className="animate-pulse space-y-4">
          <div className="h-20 bg-slate-200 dark:bg-slate-700 rounded" />
          <div className="h-20 bg-slate-200 dark:bg-slate-700 rounded" />
        </div>
      </Widget>
    );
  }

  const prayerRequests = stats?.prayers.byType.prayer_request ?? 0;
  const praiseReports = stats?.prayers.byType.praise_report ?? 0;

  return (
    <Widget id="today-stats" title="Recent Activity" isEditMode={isEditMode}>
      <div className="space-y-4">
        {/* Today's submissions */}
        <div className="bg-gradient-to-br from-primary-50 to-primary-100 dark:from-primary-900/20 dark:to-primary-800/20 rounded-lg p-4">
          <div className="text-3xl font-bold text-primary-600 dark:text-primary-400">
            {stats?.prayers.today ?? 0}
          </div>
          <div className="text-sm text-primary-700 dark:text-primary-300 mt-1">
            Submitted Today
          </div>
        </div>

        {/* This week's submissions */}
        <div className="bg-gradient-to-br from-blue-50 to-blue-100 dark:from-blue-900/20 dark:to-blue-800/20 rounded-lg p-4">
          <div className="text-3xl font-bold text-blue-600 dark:text-blue-400">
            {stats?.prayers.thisWeek ?? 0}
          </div>
          <div className="text-sm text-blue-700 dark:text-blue-300 mt-1">
            This Week
          </div>
        </div>

        {/* Type breakdown */}
        <div className="grid grid-cols-2 gap-3 pt-2 border-t border-slate-200 dark:border-slate-700">
          <div className="text-center">
            <div className="text-xl font-semibold text-slate-900 dark:text-white">
              {prayerRequests}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Prayer Requests
            </div>
          </div>
          <div className="text-center">
            <div className="text-xl font-semibold text-slate-900 dark:text-white">
              {praiseReports}
            </div>
            <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              Answered Prayers
            </div>
          </div>
        </div>
      </div>
    </Widget>
  );
}
